import { TemplateLight } from "@/Appointments/Models/Scheduling/TemplateLight";
import { ITemplateTabModel } from "@/Appointments/Models/UI/Scheduling/ITemplateTabModel";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { Popup } from "@/Common/Components/Modals/Popup";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { AppointmentSchedulerV2 } from "./AppointmentSchedulerV2";

interface IMainTemplateTabProps {
    Model: ITemplateTabModel;
}

class MainTemplateTabState {

}

class MainTemplateTab extends React.Component<IMainTemplateTabProps, MainTemplateTabState> {
    public componentDidMount(): void {
        LocalEvent.Dispatch(LocalOperations.TemplateTab.LoadLightTemplate);
        $(window).trigger("resize");
    }

    public componentDidUpdate(): void {
        $(window).trigger("resize");
    }

    public render(): JSX.Element {
        var intervenorRender = null;
        if (this.props.Model.get("IntervenorsList").size > 0) {
            intervenorRender = this.props.Model.get("IntervenorsList").toArray().map((item, idx) => (
                <div key={"n_" + idx}>
                    <span>{item.NameWithPrefix}</span>
                </div>
            ));
        }

        return (
            <div className="workspace">
                <div className="fxheight medical-summary-container">
                    {this.props.Model.get("OpenIntervenorPopup") === true && (
                        <Popup
                            cssClass="double-booking"
                            title={cacheStore.GetString("StaffLabel")}
                            onCloseDelegate={this.onIntervenorClick.bind(this)}
                        >
                            <div className="p-body">
                                {intervenorRender}
                            </div>

                            <div className="p-footer">
                                <div className="text-right">
                                    <ButtonControl
                                        variant="neutral"
                                        onClick={this.onIntervenorClick.bind(this)}
                                        label={cacheStore.GetString("CloseLabel")}
                                    />
                                </div>
                            </div>
                        </Popup>
                    )}
                    {this.props.Model.get("DeletePopupOpen") === true && (
                        <Popup
                            cssClass="double-booking"
                            title={cacheStore.GetString("WarningLabel")}
                            onCloseDelegate={this.onDeletePopupClick.bind(this)}
                        >
                            <div className="p-body">
                                <div>
                                    <span> {cacheStore.GetString("DeleteTemplate1Label")}: </span>
                                    <strong>{" " + this.props.Model.get("SelectedTemplateName") + " "}</strong>
                                </div>
                                <div>
                                    <span>{cacheStore.GetString("DeleteTemplate2Label")}</span>
                                </div>
                            </div>

                            <div className="p-footer flex-display flex-end">
                                <ButtonGroup>
                                    <ButtonControl
                                        variant="neutral"
                                        onClick={this.onDeletePopupClick.bind(this)}
                                        label={cacheStore.GetString("CancelLabel")}
                                    />
                                    <ButtonControl
                                        variant="error"
                                        onClick={this.onDeleteTemplateClick.bind(this)}
                                        label={cacheStore.GetString("DeleteLabel")}
                                        dataCy="templatePopup-delete"
                                    />
                                </ButtonGroup>
                            </div>
                        </Popup>
                    )}
                    <div className="tb medical-summary">
                        {this.renderLeftSide()}
                        {this.renderRightSide()}
                    </div>
                </div>

                <div className="ws-footer table-pager-footer" style={{ height: "0px", padding: "0px", margin: "0px" }} />
            </div>
        );
    }

    public renderLeftSide(): JSX.Element {
        return (
            <div className="tbc full-border left-primary">
                <div className="note-search">
                    <div className="flex-container">
                        <div className="search-field" style={{ width: "100%", marginRight: "5px" }}>
                            <div className="gf">
                                <span className="glyphicon glyphicon-search" />
                            </div>
                            <TextboxControl debounceMs={400} value={this.props.Model.get("SearchText")} className="fullWidth" placeholder={cacheStore.GetString("SearchLabel")} operation={LocalOperations.TemplateTab.SearchText} dataCy="template-search" />
                        </div>
                    </div>
                    <div className="clearfix" style={{ marginTop: "15px" }}>
                        <div className="pull-right">
                            <a style={{ marginLeft: "5px" }} onClick={this.onNewTemplateClick.bind(this)} data-cy="template-new">{cacheStore.GetString("NewTemplateLabel")}</a>
                        </div>
                    </div>
                </div>
                {this.renderTemplate()}
            </div>
        );
    }

    public renderRightSide(): JSX.Element {
        return (
            <div>
                <div className="flex-container" style={{ paddingTop: "15px", paddingBottom: "10px", alignItems: "center" }}>
                    <h3 className="thin-font no-margin" style={{ paddingLeft: "5px" }}>{this.props.Model.get("SelectedTemplateName")}</h3>
                    {this.props.Model.get("IntervenorsList").size > 0 && (
                        <a onClick={this.onIntervenorClick.bind(this)}>{this.props.Model.get("IntervenorsList").size + " " + cacheStore.GetString("StaffLabel")}</a>
                    )}

                    <div className="text-right push-right-5" style={{ paddingBottom: "5px" }}>
                        {!IsNullOrWhiteSpace(this.props.Model.get("SelectedTemplateId")) && (
                            <ButtonGroup>
                                <ButtonControl
                                    variant="brand"
                                    onClick={this.onModifyClick.bind(this)}
                                    label={cacheStore.GetString("ModifyLabel")}
                                    dataCy="template-modify"
                                />
                                <ButtonControl
                                    variant="error"
                                    onClick={this.onDeletePopupClick.bind(this)}
                                    label={cacheStore.GetString("DeleteLabel")}
                                    dataCy="template-delete"
                                />
                            </ButtonGroup>
                        )}
                    </div>
                </div>
                <div className="summary-container" style={{ display: "flex", flexDirection: "column" }} data-cy="template-container">
                    <div className="" style={{ height: "100%" }}>

                        <AppointmentSchedulerV2
                            workDays={this.props.Model.get("SelectedTemplateWorkDay")}
                            minorAxisResolutionInMinutes={15}
                            onSelectRulesetOperation={LocalOperations.OpenScheduleTab.SelectExistingRuleset}
                            selectedRulesetId={1}
                            fullWidth={false}
                        />
                    </div>

                </div>
            </div>

        );
    }

    public renderTemplate(): JSX.Element {
        var templateList = this.props.Model.get("TemplateList").toArray().sortByProperty(v => v.Name);
        var templateRender = templateList.map((item: TemplateLight, idx: number) => (
            <div className="pointer" key={"n_" + idx} onClick={this.onTemplateClick.bind(this, item)}>
                <div className="med-note">
                    <div className="tb">
                        <div className="tbc">
                            <p><strong>{item.Name}</strong></p>
                        </div>
                    </div>
                </div>
            </div>
        ));
        return (
            <div className="note-collection scrollable" data-cy="template-list">
                {templateRender}
            </div>
        );
    }

    private onTemplateClick(item: TemplateLight): void {
        var op = new LocalEvent(LocalOperations.TemplateTab.LoadTemplateInfo);
        op.AddItem("item", item);
        LocalEventDispatcher.dispatch(op);
    }

    private onDeleteTemplateClick(): void {
        LocalEvent.Dispatch(LocalOperations.TemplateTab.DeleteTemplate);
    }

    private onNewTemplateClick(): void {
        LocalEvent.Dispatch(LocalOperations.TemplateTab.NewTemplateClick);
    }

    private onModifyClick(): void {
        LocalEvent.Dispatch(LocalOperations.TemplateTab.ModifyClick);
    }

    private onIntervenorClick(): void {
        LocalEvent.Dispatch(LocalOperations.TemplateTab.OpenIntervenorPopup);
    }

    private onDeletePopupClick(): void {
        LocalEvent.Dispatch(LocalOperations.TemplateTab.OpenDeletePopup);
    }
}

export { MainTemplateTab };
